import { ExternalLink, Info, Hash } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-[var(--border)] bg-[var(--bg-soft)] px-4 py-6 mt-auto">
      <div className="mx-auto max-w-[1180px] flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[var(--muted)]">
        <div className="text-center sm:text-left">
          <p>
            <strong className="text-[var(--text)]">PokeGuru</strong> · A fast, open Pokémon card database
          </p>
          <div className="mt-2 flex flex-wrap justify-center sm:justify-start gap-x-4 gap-y-2 text-xs">
            <Link to="/about" className="flex items-center gap-1 hover:text-[var(--link)] transition-colors">
              <Info size={12} />
              About Project
            </Link>
            <Link to="/about#tags" className="flex items-center gap-1 hover:text-[var(--link)] transition-colors">
              <Hash size={12} />
              Search Tags
            </Link>
            <a
              href="https://pokemontcg.io"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 hover:text-[var(--link)]"
            >
              <ExternalLink size={12} />
              Pokémon TCG API
            </a>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <a
            href="https://github.com/lin4cre/PokeGuru"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 hover:text-[var(--text)] transition-colors"
            aria-label="View source on GitHub"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"/>
              <path d="M9 18c-4.51 2-5-2-7-2"/>
            </svg>
            <span>GitHub</span>
          </a>
        </div>
      </div>

      <div className="mx-auto max-w-[1180px] mt-4 pt-4 border-t border-[var(--border)] text-center text-xs text-[var(--muted)]">
        <p>
          Pokémon and all related names are trademarks of Nintendo, Game Freak &amp; The Pokémon Company.
        </p>
        <p className="mt-1">
          This is an unofficial, non-commercial fan project. Released under the{' '}
          <a href="https://opensource.org/licenses/MIT" target="_blank" rel="noopener noreferrer" className="hover:text-[var(--link)]">
            MIT License
          </a>
        </p>
      </div>
    </footer>
  );
}
